import HomePage from "./views/home";
import ReturnAndRefundPolicy from "./views/returnAndRefundPolicy";
import ShippingPolicy from "./views/shippingPolicy";
import Products from "./views/products";
import ProductDetails from "./views/productDetails";
import PrivacyPolicy from "./views/privacyPolicy";
import CancelPolicy from "./views/cancelPolicy";
import TermsCondition from "./views/termsCondition";
import AboutUs from "./views/aboutUs";
import UpsaleoDeliveryShippingGuide from "./views/upsaleoDeliveryShippingGuide";
import Pricing from "./views/pricing";
import BeASupplier from "./views/beAsupplier";
import HelpCenter from "./views/helpCenter";
import ContactUs from "./views/contactUs";
import CantonFairForm from "./views/questionnaireFormIB";
import RegistrationFormCS from "./views/contactusCS";
import SellingGuide from "./views/sellingGuide";
import HowDropshippingWork from "./views/howDropshippingWork";
import WhyDropshippingWithUs from "./views/whyDropshippingWithUs";
import FeaturedCategory from "./views/featuredCategory";
import Cart from "./views/checkout/cart";
import Address from "./views/checkout/address";
import Payment from "./views/checkout/payment";
import Checkout from "./views/checkout";

import ThankYouPage from "./component/common/orderConfirmationPage";
import Investors from "./views/investor";
import Sellers from "./views/seller";
import PaymentStatus from "./views/checkout/payment/PaymentStatus";

import CookiesPolicy from "./views/cookiesPolicy";
import RechargeRequestPage from "./views/rechargeRequest";
import PaymentForm from "./views/payment/PaymentForm";
import CCAvenuePaymentStatus from "./views/payment/PaymentStatus";

const routes = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/shipping-policy",
    element: <ShippingPolicy />,
  },
  {
    path: "/return-refund-policy",
    element: <ReturnAndRefundPolicy />,
  },
  { path: "/selling-guide", element: <SellingGuide /> },
  {
    path: "/collection",
    element: <Products />,
  },
  {
    path: "/collection/:category",
    element: <Products />,
  },
  {
    path: "/collection/:category/:subCategory",
    element: <Products />,
  },
  {
    path: "/collection/:category/:subCategory/:subSubCategory",
    element: <Products />,
  },
  // new slug-based category paths (catch depth of any subcategories)
  {
    path: "/category/:categorySlug/*",
    element: <Products />,
  },
  {
    path: "/product-details",
    element: <ProductDetails />,
  },
  {
    // Legacy URL - redirect to new format
    path: "/product-details/:skuId/:slug",
    element: <ProductDetails />,
  },
  {
    // Legacy URL with variant - redirect to new format
    path: "/product-details/:skuId/:variantId/:slug",
    element: <ProductDetails />,
  },
  {
    // Legacy /p/ URL - redirect to new format
    path: "/p/:skuId/:slug",
    element: <ProductDetails />,
  },
  {
    // Legacy /p/ URL with variant - redirect to new format
    path: "/p/:skuId/:variantId/:slug",
    element: <ProductDetails />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/cookies-policy",
    element: <CookiesPolicy />,
  },
  {
    path: "/cancel-policy",
    element: <CancelPolicy />,
  },
  {
    path: "/terms-and-conditions",
    element: <TermsCondition />,
  },
  {
    path: "/about-us",
    element: <AboutUs />,
  },
  {
    path: "/delivery-and-shipping-guide",
    element: <UpsaleoDeliveryShippingGuide />,
  },
  {
    path: "/pricing",
    element: <Pricing />,
  },
  {
    path: "/be-a-seller",
    element: <BeASupplier />,
  },
  {
    path: "/help-center",
    element: <HelpCenter />,
  },
  {
    path: "/rc/imcash",
    element: <RechargeRequestPage />,
  },
  {
    path: "/contact-us",
    element: <ContactUs />,
  },
  {
    path: "/canton2026",
    element: <CantonFairForm />,
  },
  {
    path: "/contact-us-cs",
    element: <RegistrationFormCS />,
  },
  {
    path: "/why-work-with-importerr",
    element: <WhyDropshippingWithUs />,
  },
  {
    path: "/how-dropshiping-work",
    element: <HowDropshippingWork />,
  },
  {
    path: "/fc/:category",
    element: <FeaturedCategory />,
  },
  {
    path: "/tag/:keyword",
    element: <Products />,
  },
  {
    path: '/checkout/*',
    element: <Checkout />,
    children: [
      {
        path: 'cart',
        element: <Cart />,
      },
      {
        path: 'address',
        element: <Address />,
      },
      {
        path: 'payment',
        element: <Payment />,
      },
    ],
  },

  {
    path: '/order-confirm',
    element: <ThankYouPage />,
  },

  // CCAvenue payment routes
  {
    path: '/payment',
    element: <PaymentForm />,
  },
  {
    path: '/payment-status',
    element: <CCAvenuePaymentStatus />,
  },

  // SEO-friendly clean product URLs (must be at end to avoid conflicts)
  // Format: /{skuId}/{slug} or /{skuId}/{variantId}/{slug}
  {
    // Clean URL with variant: /{skuId}/{variantId}/{slug}
    path: "/:skuId/:variantId/:slug",
    element: <ProductDetails />,
  },
  {
    // Clean URL without variant: /{skuId}/{slug}
    path: "/:skuId/:slug",
    element: <ProductDetails />,
  },

  //  {
  //   path: "/investor",
  //   element: <Investors />,
  // },
  //  {
  //   path: "seller",
  //   element: <Sellers />,
  // },
];

export default routes;
